import { FC } from 'react';
import { InlineNotification } from '@carbon/react';
import { formatTcWorkspaceDate } from 'utils/dates';
import type { DivisionOrderSourceDocumentRef } from './types';

interface SourceDocumentBannerProps {
  sourceDocument?: DivisionOrderSourceDocumentRef | null;
}

// Provisioned/auto-connected DOs carry no Salesforce link, so — mirroring the
// AFE detail-page pattern — surface an "Auto-Connected" banner naming the
// originating source document. Carbon's InlineNotification requires a plain
// string subtitle and rejects interactive children, so the document is named as
// text here; the clickable link to it lives in the catalog's Source column.
const SourceDocumentBanner: FC<SourceDocumentBannerProps> = ({
  sourceDocument,
}) => {
  if (!sourceDocument) return null;

  const docLabel =
    sourceDocument.documentTitle ?? `Document #${sourceDocument.id}`;
  const populatedAt = formatTcWorkspaceDate(sourceDocument.autoConnectedAt);

  return (
    <InlineNotification
      kind="info"
      lowContrast
      hideCloseButton
      title="Auto-Connected"
      subtitle={`Auto-populated from ${docLabel} on ${populatedAt}.`}
    />
  );
};

export { SourceDocumentBanner };
